import React from 'react';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import ClientLinearBar from './ClientLinearBar';
import { useClient } from '../../../context/ClientContext';
import ClientFooter from './ClientFooter';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

function ClientQuestionBase( {
  IsShowBackIcon = false,
  backButtonHandler,
  aimdLinearBarValue,
  isShowStepper = true,
  isBottomLogoVisible = true,
  children,
} ) {
  const isSmallHeight = useMediaQuery( '(max-height:700px)' );
  const isLaptop = useMediaQuery( '(min-width:1024px)' );
  const { theme } = useClient();

  return (
    <Box sx={ {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      minHeight: {
        xs: '88vh',
        sm: '98vh',
        md: '97vh',
        lg: '97vh'
      },
      position: 'relative',
      boxSizing: 'border-box',
      padding: {
        xs: '10px',
        sm: '10px 20px',
        md: '20px 40px',
        lg: '20px 50px'
      },

      marginTop: '1rem',
      width: '100%',
      fontFamily: 'Poppins',
    } }>
      {/* Header part */ }
      <Box sx={ {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        mb: 3
      } }>
        {/* Container for progress bar and back button */ }
        <Box sx={ {
          width: {
            xs: '100%',
            sm: '85%',
            md: '75%',
            lg: '70%'
          },
          position: 'relative'
        } }>
          {/* Back button positioned above the left end of progress bar */ }
          { IsShowBackIcon && (
            <Box
              onClick={ backButtonHandler }
              sx={ {
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                left: '0',
              } }
            >
              <Box sx={ { display: 'flex', alignItems: 'center', justifyContent: 'center' } }>
                <ArrowBackIosNewIcon sx={ {
                  fontSize: 12,
                  color: theme.primaryColor,
                  padding: '5px',
                  borderRadius: '100px',
                  backgroundColor: 'rgba(241, 92, 48, 0.1)'
                } } />
              </Box>
              <Typography sx={ {
                color: theme.primaryColor,
                fontWeight: 600,
                fontSize: '14px',
                pl: 1
              } }>
                Back
              </Typography>
            </Box>
          ) }

          {/* Progress bar */ }
          { isShowStepper && (
            <ClientLinearBar
              value={ aimdLinearBarValue }
              barHeight={ isLaptop ? '16px' : '10px' }
              color={ theme.linearBarColor }
              bg={ theme.linearBg }
            />
          ) }
        </Box>
      </Box>

      {/* Main content */ }
      <Stack sx={ {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: {
          lg: 0.5,
          md: 0.5,
          sm: 0.5,
          xs: isSmallHeight ? 0.3 : 0.5
        },
        width: '100%',
        boxSizing: 'border-box',
        padding: '10px',
        overflowY: 'scroll',
        paddingBottom: isBottomLogoVisible ? '100px' : '0px'
      } }>
        { children }
      </Stack>

      {/* Footer */ }
      { isBottomLogoVisible && theme.showBottomLogo && (
        <Stack style={ {
          position: 'absolute',
          bottom: 10,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        } }>
          <ClientFooter
            footerTitle={ theme.footerTitle }
            logo={ theme.logo }
          />
        </Stack>
      ) }
    </Box>
  );
}

export default ClientQuestionBase;